/*
*@Author: dcl
*@Description: 热销产品
*@Date: 2022-11-14 11:27:35
*/

<template>
    <div class="p-box">
        <div class="box-logo">
            <div class="logo-img">
                <!-- <el-image class="img-box" :src="product_1" fit="none" /> -->
                <div class="img-txt">智能&nbsp;~&nbsp;安全&nbsp;~&nbsp;效率&nbsp;~&nbsp;全面<br />为客户提供最优服务
                </div>
            </div>
        </div>
        <div class="box-content">
            <!-- <div class="content-txt">我们的产品</div> -->
            <div class="content-left" @click="changeMove(-1)">
                <i class="el-icon-arrow-left"></i>
            </div>
            <div class="content-cell">
                <div ref="cellImgRef" class="cell-img" :style="changePic">
                    <div class="img-con" v-for="(item, index) in conList" :key="index + 'conList'">
                        <el-image class="box-img" :src="item.img" fit="cover" />
                        <div class="con-txt">
                            <div class="txt-title">
                                {{ item.name }}
                            </div>
                            <div class="txt-pot">
                                {{ item.describe }}
                            </div>
                            <!-- <div class="txt-btn">
                                <div class="btn" v-if="item.link" @click="changeLinkBtn(item.link)">去投保</div>
                            </div> -->
                        </div>
                    </div>
                </div>
            </div>
            <div class="content-right" @click="changeMove(1)">
                <i class="el-icon-arrow-right"></i>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            imgWidth: 0,
            imgIndex: 1,
            conList: [{
                name: "车辆保险",
                img: require("../../assets/product_2.jpg"),
                describe: '指对机动车辆因为自然灾害或意外事故所导致的人身伤亡、财产损失进行保障。汽车保险包括交强险和商业车险，其中，交强险属于强制缴纳的车险，而商业车险则还包括了车损险、第三者责任险、座位险、划痕险等，但是商业车险并不强制缴纳，车主可以根据自己的实际需求和保费预算选择投保。',
                list: ["个人意外险", "普通意外伤害保险", "特殊意外伤害保险"],
                // link: 'https://www.elongai.com/#/?appcode=1&token=null&appbrand='
            },
            {
                name: "财 产 险",
                img: require("../../assets/product_3.jpg"),
                describe: '指投保人根据合同约定，向保险人交付保险费，保险人按保险合同的约定对所承保的财产及其有关利益因自然灾害或意外事故造成的损失承担赔偿责任的保险。财产保险业务，包括财产损失保险、责任保险、信用保险、保证保险等保险业务。可保财产，包括物质形态和非物质形态的财产及其有关利益。以物质形态的财产及其相关利益作为保险标的的，通常称为财产损失保险。',
                list: ["财产损失保险普通家", "财险、企财险", "信用保证保险"]
            },
            {
                name: "责 任 险",
                img: require("../../assets/product_4.jpg"),
                describe: '指保险人在被保险人依法应对第三者负赔偿民事责任，并被提出赔偿要求时，承担赔偿责任的财产保险形式。责任保险以被保险人对他人依法应负的民事赔偿责任为保险标的，在合同中无保险金额，而规定赔偿限额。责任保险仅承保被保险人的过失侵权民事责任，对故意行为造成的损害不负责任，除特别约定外，通常不包括合同违约责任。',
                list: ["健康险", "普通意外险", "普通健康险"]
            },
            {
                name: "货 运 险",
                img: require("../../assets/product_5.jpg"),
                describe: '保险公司对运输过程中货物遭受意外风险损失负责赔偿的一种商业保险业务。货运险的承保对象为运输工具。货运险的承保范围，一般分基本险和附加险。基本险有：财产损失保险：指对遭受各种自然灾害和意外事故所造成的损失负赔偿责任的财产险。（自然灾害如：洪水、暴雨、暴风、雷击、泥石流等;意外事故如：火灾、爆炸、碰撞、倾覆等。）',
            },
            {
                name: "意 外 险",
                img: require("../../assets/product_6.jpg"),
                describe: '指人身意外保险，又称为意外或伤害保险，是指投保人向保险公司缴纳一定金额的保费当被保险人在保险期限内遭受意外伤害，并以此为直接原因造成死亡或残废时，保险公司按照保险合同的约定向被保险人或受益人支付一定数量保险金的保险。意外险包括意外身故、意外残疾和意外医疗保障。',
            },
            {
                name: "健 康 险",
                img: require("../../assets/product_7.jpg"),
                describe: '主要包括医疗保险、疾病保险、失能收入损失保险、护理保险以及医疗意外保险等。是指在被保险人身体出现疾病时，由保险人向其支付保险金的人身保险。健康保险的支付范围通常包括医疗费用、收入损失、丧葬费及遗属生活费等。此种保险多与伤害保险合办，也有与人寿保险合办的。为防止道德危险，办理健康保险时，保险人通常都规定一段试保期间，对被保险人在此期间后发生疾病造成的损失，保险人方负赔偿责任。',
            }
            ],
            product_1: require("../../assets/product_1.jpg")
        }
    },
    computed: {
        changePic() {
            return {
                transform: `translate3d(${this.imgWidth}rem, 0, 0)`
            }
        }
    },
    methods: {
        changeMove(v) {
            let fz = Number(getComputedStyle(window.document.documentElement)['font-size'].slice(0, -2))
            if (v > 0) {
                if (this.imgIndex + 4 < this.conList.length) {
                    this.imgIndex++
                } else {
                    // this.imgIndex = 0
                }
            } else {
                if (this.imgIndex <= 0) {
                    // this.imgIndex = 0
                } else {
                    this.imgIndex--
                }
            }
            this.imgWidth = -((this.$refs.cellImgRef.offsetWidth / fz - 13.93 * 4) / 4 + 13.93) * this.imgIndex
        },
        changeLinkBtn(v) {
            window.location.href = v
        }
    }
};
</script>

<style lang="less" scoped>
.p-box {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: left;
    position: relative;
    // justify-content: center;

    .box-logo {
        max-width: 1920px;
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        // margin-bottom: 60px;

        .logo-img {
            position: relative;
            width: 100%;
            height: 19.4rem;
            margin-bottom: 14rem;
            background: url('../../assets/product_1.jpg') no-repeat center;
            background-size: cover;

            .img-txt {
                position: absolute;
                color: #EDEDED;
                top: 3.57rem;
                left: 8rem;
                width: 18.33rem;
                height: 4.13rem;
            }
        }

    }

    .box-content {
        display: flex;
        align-items: center;
        justify-content: center;
        // justify-content: space-around;
        flex-direction: row;
        // width: initial;
        position: absolute;
        max-width: 1920px;
        // margin-top: -9.53rem;
        top: 10.067rem;

        // .content-txt {
        //     font-size: 35px;
        //     margin: 20px;
        // }

        .content-left,
        .content-right {
            width: 1.6rem;
            height: 1.6rem;
            border-radius: 5px;
            background-color: #ABABAB;
            color: #ffffff;
            font-size: 1rem;
            line-height: 1.6rem;
            text-align: center;
        }

        .content-left:hover,
        .content-right:hover {
            cursor: pointer;
            user-select: none;
            background-color: #FF9600;
        }

        .content-cell {
            display: flex;
            flex-direction: row;
            width: calc(100% - 5.04rem);
            overflow: hidden;

            .cell-img {
                display: flex;
                flex-direction: row;
                width: 100%;

                .img-con {
                    margin: 0px calc((100% - 13.93rem * 4) / 8) 10px;
                    background-color: #ffffff;

                    .box-img {
                        width: 13.93rem;
                        height: 9.33rem;
                    }

                    .con-txt {
                        padding: 1.03rem 1.3rem;
                        height: 10.8rem;
                        box-shadow: 0px 0.1rem 0.17rem 0.067rem #ccc;
                        margin-top: -0.17rem;

                        .txt-title {
                            color: #333333;
                            font-size: 0.73rem;
                            font-weight: bold;
                        }

                        .txt-pot {
                            font-size: 0.53rem;
                            margin-top: .3rem;
                            line-height: .8rem;
                            letter-spacing: .3px;
                        }

                        .txt-btn {
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            text-align: center;
                            width: 10.67rem;
                            height: 1.47rem;
                            margin-top: 1rem;

                            .btn {
                                width: 50%;
                                height: 1.47rem;
                                line-height: 1.47rem;
                                cursor: pointer;
                                background-color: #FF9600;
                                font-size: 0.8rem;
                                border-radius: 1rem;
                                color: #ffffff;
                            }
                        }

                        // .txt-pot2 {
                        //     margin-top: 1.03rem;
                        // }
                    }
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/view/Product/index.vue